/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SearchSessionState;
(function (SearchSessionState) {
    let status;
    (function (status) {
        status["ACTIVE"] = "active";
        status["COMPLETED"] = "completed";
        status["PAUSED"] = "paused";
        status["PROCESSING"] = "processing";
        status["ERROR"] = "error";
    })(status = SearchSessionState.status || (SearchSessionState.status = {}));
})(SearchSessionState || (SearchSessionState = {}));
